module.exports = __webpack_public_path__ + "img/icon-dashboard-white.1f4ab946.svg";